import React from 'react';

const RegistrationFooter2 = (props) => {

	const { lessonLocation } = props;

	let directionText = null;

	switch (lessonLocation.toLowerCase()) {
		case 'woodbury':
		  directionText = (
			<React.Fragment>
				<p>
					Woodbury lessons are held at Christ Church, Woodbury at 62 Delaware Ave.  Please park in the lot behind the church and enter through the side glass door by the garden, across from the courthouse parking lot (careful to not park in this lot).
				</p>
				<p>
					The Lower Assembly room is down the stairs and to the left.  The Choir room is down the stairs, to the left and through the door on the far left. The Upper Assembly room is up the stairs and through the door on the right.
				</p>
			</React.Fragment>
			);
		  break;
		case 'pitman':
		default:
		  directionText = (
			<React.Fragment>
				<p>
					Pitman lessons are held at the First Baptist Church in Pitman at 30 N Broadway, park in the lot and enter through the door with the green mailbox. S1, S2, S3 - up the stairs and through the double doors on the left, cross the Sanctuary. S4 is the Sanctuary. S5, enter the Sanctuary as above, exit through the doors on the left, go down the stairs, studio is on the right. S6 is down the stairs and to the left.  S7 is on the lobby level - turn right as you enter the lobby.
				</p>
				<p>
					Lessons with Lauren Canna are held at 40 S Broadway 101-A, the office facing Second Ave.
				</p>
			</React.Fragment>
			);
		  break;
	};

	return (
		<footer className='registrationFooter'>
			<div className='content twoColumns'>
				<div className='column'>
					<h2>AfterSchool Music</h2>
					PO Box 345<br />
					Pitman NJ 08071<br />
					856-55-33-11-0 (text only)<br />
					<a href="mailto:pitmanmusiclessons@gmail.com" target="_self">pitmanmusiclessons@gmail.com</a><br />
					<a href="mailto:woodburymusiclessons@gmail.com" target="_self">woodburymusiclessons@gmail.com</a>
				</div>
				<div className='column'>
					{directionText}
				</div>
			</div>
		</footer>
	);
};

export default RegistrationFooter2;
